import React from 'react';
import ReactMarkdown from 'react-markdown';

interface MarkdownRendererProps {
  content: string;
  className?: string;
}

export const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content, className = '' }) => {
  return (
    <div className={`prose prose-sm max-w-none ${className}`}>
      <ReactMarkdown
        components={{
          // Ensure lists render properly
          ul: ({ children }) => (
            <ul className="list-disc list-inside space-y-1 my-2">{children}</ul>
          ),
          ol: ({ children }) => (
            <ol className="list-decimal list-inside space-y-1 my-2">{children}</ol>
          ),
          li: ({ children }) => (
            <li className="text-sm">{children}</li>
          ),
          // Style headings
          h1: ({ children }) => (
            <h1 className="text-lg font-bold my-2">{children}</h1>
          ),
          h2: ({ children }) => (
            <h2 className="text-base font-bold my-2">{children}</h2>
          ),
          h3: ({ children }) => (
            <h3 className="text-sm font-bold my-1">{children}</h3>
          ),
          // Style bold text
          strong: ({ children }) => (
            <strong className="font-semibold">{children}</strong>
          ),
          // Style links
          a: ({ href, children }) => (
            <a 
              href={href} 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 underline"
            >
              {children}
            </a>
          ),
          // Style paragraphs
          p: ({ children }) => (
            <p className="my-2 leading-relaxed">{children}</p>
          ),
          // Add horizontal rule support
          hr: () => (
            <hr className="my-4 border-t border-gray-300" />
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}; 